<template>
  <div class="item transport">
    <div class="date">
      {{ utilDateFlightfox(transport.time_depart) }}
    </div>
    <div class="provider">
      <div class="col1">
        <div class="icon">&#x1f4cd;</div>
      </div>
      <div class="col2">
        <div>{{ transport.provider }}&nbsp;&middot;&nbsp;{{ location }}</div>
      </div>
      <div class="col3">
        {{ transport.type }}
      </div>
    </div>
    <div class="schedule">
      <div class="col1 path">
        <div class="dot top" />
        <div class="line" />
        <div class="dot bot" />
      </div>
      <div class="col2">
        <div class="avatar">
          <a :href="map" target="_blank">
            <span class="icon">&#x1f4cd;</span>
            <span class="map">Map</span>
          </a>
        </div>
        <div class="timing">
          <div class="row">
            <div class="pri">
              {{ utilTime(transport.time_depart) }}
            </div>
            <div class="sec">
              {{ utilDateFlightfox(transport.time_depart) }}
            </div>
          </div>
          <div class="row">
            <div class="pri">
              {{ utilTime(transport.time_arrive) }}
            </div>
            <div class="sec">
              {{ utilDateFlightfox(transport.time_arrive) }}
            </div>
          </div>
        </div>
      </div>
      <div class="col3">
        {{ utilDurationItineraryDates(transport.time_depart, transport.time_arrive) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import DateTime from "../../utils/datetime";

const { utilDateFlightfox, utilTime, utilDurationItineraryDates } = DateTime();

const props = defineProps(["transport"]);

const location = computed(() => {
  if (props.transport.location_depart === props.transport.location_arrive) {
    return props.transport.location_depart;
  } else {
    return props.transport.location_depart + " to " + props.transport.location_arrive;
  }
});

const map = computed(() => {
  const query = props.transport.provider + " " + props.transport.location_depart;
  const queryEncoded = query.replace(/ /g, "+");
  return "http://maps.google.com/?q=" + queryEncoded;
});
</script>

<style lang="less">
#itineraries {
  .transport {
    .avatar {
      a {
        display: block;
        width: 3rem;

        span {
          display: block;
          text-align: center;
        }

        .icon {
          color: @dark;
          font-size: 1.625rem;
          line-height: 1.625rem;
        }

        .map {
          font-size: 0.75rem;
        }
      }
    }
  }
}
</style>
